<div class="loading-wheel-container">
  <core-loader variant="circular"></core-loader>
</div>
